module.exports = "@import url(folder/stylesheet-import1.css);\r\n\r\n.rule-direct {\r\n\tbackground: lightgreen;\r\n}\n.generated { color: red; }"


/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/raw-loader!(webpack)/~/val-loader!./loaders/_css/generateCss.js
 ** module id = 1
 ** module chunks = 0
 **/